package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.OAuthProvider
import fr.manyverse.app.domain.repository.AuthRepository

class SignInWithOAuthUseCase(private val authRepository: AuthRepository) {
    suspend operator fun invoke(provider: OAuthProvider): Result<Unit> {
        return authRepository.signInWithOAuth(provider)
    }
}
